module.exports = __webpack_public_path__ + "img/image6_en.fca1b358.png";